var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenciTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #aa00e7;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 51.5,
    cy: 49.8,
    rx: 27.5,
    ry: 26.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.2,43.5c-1-.8-1.5-2-1.6-3.4h0v-4.7h-10.8c-.7,0-1.3.3-1.8.7-.5.5-.7,1.1-.7,1.8v23.7c0,.7.3,1.3.7,1.8.5.5,1.1.7,1.8.7h16.5c.7,0,1.3-.3,1.8-.7.5-.5.7-1.1.7-1.8v-16.8h-2.8c-1.6,0-2.9-.5-3.8-1.2h0ZM53.2,59.8h-8.5c-.6,0-1-.5-1-1s.5-1,1-1h8.5c.6,0,1,.5,1,1s-.5,1-1,1ZM54.7,54.7h-10c-.6,0-1-.5-1-1s.5-1,1-1h10c.6,0,1,.5,1,1s-.5,1-1,1ZM55.3,49.7h-10.6c-.6,0-1-.5-1-1s.5-1,1-1h10.6c.6,0,1,.5,1,1s-.5,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,7.6C26.5,7.6,7.6,26.5,7.6,50s19,42.4,42.4,42.4,42.4-19,42.4-42.5S73.4,7.6,50,7.6ZM61.5,64.8h0c-.8.8-2,1.3-3.2,1.3h-16.5c-1.2,0-2.4-.5-3.2-1.3-.8-.8-1.3-2-1.3-3.2v-23.7c0-1.2.5-2.4,1.3-3.2.8-.8,2-1.3,3.2-1.3h12.2c.3,0,.6.2.8.4l7.7,8.3c.2.2.3.4.3.7v18.8c0,1.2-.5,2.4-1.3,3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,42.8h2.4l-5.8-6.2v3.5c0,.9.4,1.5.9,2,.5.5,1.4.7,2.5.8h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenciTemplate);
export default __webpack_public_path__ + "static/media/PenciTemplate.db813342c214d5096d201935d5043e1a.svg";
export { ForwardRef as ReactComponent };